import React, { Fragment } from 'react';
import { graphql } from 'gatsby';
import Header from '@components/Header';
import { css } from '@emotion/react';
import SkyBg from '@images/sky.svg';
// import GreenBottom from '@images/green-bottom.png';
// import GreenMid from '@images/green-mid.png';
// import GreenBg from '@images/green-2-bg.png';
import Hero from '@components/Hero';
import VideoSection from '@components/VideoSection';
import FeaturesSection from '@components/FeaturesSection';
import ProductsSection from '@components/ProductsSection';
import Notification from '@components/Notification';
import Calculator from '@components/Calculator';
import CaseStudies from '@components/CaseStudies';
import Contact from '@components/Contact';
import Footer from '@components/Footer';
import Page from '@components/Page';
import BackgroundImage from 'gatsby-background-image';
import ChatWidget from '@papercups-io/chat-widget';

function Index({
  data: {
    GreenTop,
    GreenBottom,
    GreenMid,
    GreenBg,
    customPage,
    testimonialsPage,
    videosPage,
    notificationPage,
    dots
  },
  pageContext: {
    language, refs, layouts, configuration: { typeforms }
  }}) {
  const {
    hero,
    video,
    calculator,
    features,
    product,
    casestudy,
    contact
  } = customPage;
  return (
    <Page>
      <Notification notification={notificationPage.notification} />
      <div
        css={css`
          background: url(${SkyBg});
          background-size: cover;
          background-repeat: no-repeat;
        `}
        className="pt-2"
      >
        <Header
          language={language}
          refs={refs}
          layouts={layouts}
        />
        <Hero
          data={hero}
          GreenTop={GreenTop}
        />
      </div>
      <BackgroundImage
        fluid={GreenMid.sharp.fluid}
      >
        {/* <div
        css={css`
          position: relative;
          margin-top: -1px;
          margin-bottom: -1px;
          background: url(${GreenMid});
          background-size: 100% 100%;
          background-repeat: no-repeat;
        `}
      > */}
        <VideoSection data={video} videos={videosPage.videos.videos} />
        <Calculator data={calculator} />
      </BackgroundImage>
      <BackgroundImage
        fluid={GreenBottom.sharp.fluid}
        css={css`
          z-index: 1;
          width: 100%;
          padding-bottom: calc(0.093879668049 * 100%);
          background-repeat: no-repeat;
          background-size: 100% 100%;
        `}
      />
      {/* <div
        css={css`
          width: 100%;
          padding-bottom: calc(0.093879668049 * 100%);
          background: url(${GreenBottom});
          background-repeat: no-repeat;
          background-size: 100% 100%;
        `}
      /> */}
      <FeaturesSection
        data={features}
        dots={dots}
      />
      <ProductsSection data={product} />
      <BackgroundImage
        fluid={GreenBg.sharp.fluid}
        css={css`
      background-repeat: no-repeat;
      background-size: cover;
      background-position: left top;
      padding-bottom: 3rem;
    `}
      >
        {/* <div
        css={css`
          background: url(${GreenBg});
          background-repeat: no-repeat;
          background-size: cover;
          background-position: left top;
          padding-bottom: 3rem;
        `}
      > */}
        {' '}
        <CaseStudies data={testimonialsPage.testimonials} />
        <Contact data={contact} language={language} typeforms={typeforms} />
      </BackgroundImage>
      <Footer
        language={language}
        layouts={layouts}
      />
      <ChatWidget
        title='Welcome to NoSpoilers!'
        subtitle= 'Ask us anything in the chat window below 😊'
        primaryColor='#1890ff'
        greeting=''
        newMessagePlaceholder='Start typing...'
        accountId='799090e9-69ce-4034-b4ac-60f55ad4e1c6'
        baseUrl='https://stktk-dev-papercups.herokuapp.com/'
      />
    </Page>
  );
}

export default Index;

export const query = graphql`
  query($id: Int, $indexId: Int, $testimonialsId: Int, $videosId: Int, $notificationId: Int) {
    page: wordpressWpWebsites(wordpress_id: { eq: $id }) {
      ...Page
    }
    testimonialsPage: wordpressWpCustompages(wordpress_id: { eq: $testimonialsId }) {
      testimonials: childWordPressAcfTestimonialsSection {
        title
        testimonials {
          name
          text
          link {
            link_url
            link_text
          }
          image_alt {
            localFile {
              sharp: childImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
    notificationPage: wordpressWpCustompages(wordpress_id: { eq: $notificationId }) {
      notification: childWordPressAcfNotificationSection {
        title
        body
        image {
          localFile {
            sharp: childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
        link {
          link_url
          link_text
        }
      }
    }
    videosPage: wordpressWpCustompages(wordpress_id: { eq: $videosId }) {
      videos: childWordPressAcfVideosSection {
        videos {
          title
          video_id
          description
          type
        }
      }
    }
    dots: file(relativePath: { eq: "dotted-bg.png" }) {
     sharp: childImageSharp {
       fluid {
         ...GatsbyImageSharpFluid
        }
      }
    }
    GreenTop: file(relativePath: { eq: "green-top.png" }) {
     sharp: childImageSharp {
       fluid {
         ...GatsbyImageSharpFluid
        }
      }
    }
    GreenBottom: file(relativePath: { eq: "green-bottom.png" }) {
      sharp: childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    GreenMid: file(relativePath: { eq: "green-mid.png" }) {
      sharp: childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    GreenBg: file(relativePath: { eq: "green-2-bg.png" }) {
      sharp: childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    customPage: wordpressWpCustompages(wordpress_id: { eq: $indexId }) {
      wordpress_id
      acf {
        language
      }
      hero: childWordPressAcfHeroSection {
        title: hero_title
        text: hero_text
        link {
          text: link_text
          url: link_url
          style: link_style
        }
      }
      video: childWordPressAcfVideoSection {
        title: video_teaser_title
		    wistia_id: video_teaser_wistia_id
      }
      calculator: childWordPressAcfCalculatorSection {
        title: calculator_title
        label: calculator_label
        savings_header: calculator_savings_header
        savings_money_label: calculator_savings_money_label
        savings_food_label: calculator_savings_food_label
        savings_water_label: calculator_savings_water_label
        pinpoints: calculator_pinpoints {
          pinpoint: revenue_pinpoint
          saved_money
          saved_food
          saved_water
        }
      }
      features: childWordPressAcfFeaturesSection {
        features_title
        features_list {
          entry {
            entry_title
          }
        }
        link {
          link_text
          link_url
          link_style
        }
      }
      product: childWordPressAcfProductSection {
        products_title
        products {
          product_title
          product_description
        }
        link {
          text: link_text
          url: link_url
        }
      }
      casestudy: childWordPressAcfCaseStudiesSection {
        title: case_studies_title
        case_studies {
          logo: case_study_logo {
            localFile {
              sharp: childImageSharp {
                fluid(quality: 100) {
                  ...GatsbyImageSharpFluid
                  presentationWidth
                }
              }
            }
          }
          link {
            link_text
            link_url
          }
          label: case_study_label
          money_value: case_study_money_value
          money_symbol: case_study_money_symbol
          food_value: case_study_food_value
          food_symbol: case_study_food_symbol
          water_value: case_study_water_value
          water_symbol: case_study_water_symbol
        }
      }
      contact: childWordPressAcfContactUsSection {
        contact_us_title
        contact_us_text
        link {
          style: link_style
          text: link_text
          url: link_url
        }
      }
    }
  }
`;